// Wizard.jsx
import React, { useState, useEffect } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import { useFirebase } from "app/firebase/context";
import { get, ref } from "firebase/database";

export const Wizard = ({
  esModificar,
  setEsModificar,
  planHistorico,
  Comunidad,
  Vecinos,
  step,
  setStep,
  isModalOpen,
  setModalOpen,
  plan,
  setPlan,
  resetFormContrato,
  refrescar,
  setRefrescar,
  datosCompletosComunidad,
}) => {
  const firebase = useFirebase();
  const nextStep = (e) => {
    setStep(step + 1);
    /*
    if (step === 1) {
      setPlan({ ...plan, plan: e.target.value });
    }*/
  };

  console.log("DETALLES DE MUERDA", isModalOpen);
  console.log("DETALLES DE MUERDA2", setModalOpen);
  const prevStep = () => {
    setStep(step - 1);
  };

  useEffect(() => {
    const tablaPrecios = async () => {
      let precioComunidad = "";
      let comisionDespacho = "";
      const numeroVecinos = plan.vecinos || 0;
      console.log("el plan", plan);
      try {
        // Tabla de precios sacada de la bbdd admin
        const snapshot = await get(ref(firebase.dbAdmin, "TablaPreciosCafComunidad"));
        //const snapshot = await get(firebase.getReferencia('TablaPrecios', null));
        let precios = [];
        snapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          precios.push(childData);
        });
        precios.map((precio) => {
          if (numeroVecinos >= precio.Desde && numeroVecinos <= precio.Hasta) {
            precioComunidad = precio.Precio;
            comisionDespacho = precio.ComisionAFCTrimeste;
          }
        });
        console.log("precioComunidad", precioComunidad);
        console.log("comisionDespacho", comisionDespacho);
        setPlan({
          ...plan,
          precioComunidad: precioComunidad,
          comisionDespacho: comisionDespacho,
          formapago: "Mensual",
        });
      } catch (error) {
        console.error("Error al cargar precios", error);
      }
    };
    tablaPrecios();
  }, []);

  return (
    <div className="container mt-5">
      {step === 1 && (
        <Step1
          onNext={nextStep}
          plan={plan}
          planHistorico={planHistorico}
          setPlan={setPlan}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
        />
      )}
      {step === 2 && (
        <Step2
          onPrev={prevStep}
          onNext={nextStep}
          setPlan={setPlan}
          plan={plan}
          planHistorico={planHistorico}
          setModalOpen={setModalOpen}
        />
      )}
      {/* Salta al 5 porque es el del pago de striper */}
      {step === 3 && (
        <Step5
          onPrev={prevStep}
          setPlan={setPlan}
          plan={plan}
          onNext={nextStep}
          refrescar={refrescar}
          setRefrescar={setRefrescar}
          datosCompletosComunidad={datosCompletosComunidad}
          planHistorico={planHistorico}
          setModalOpen={setModalOpen}
        />
      )}

      {/*
      {step === 4 && (
        <Step4
          onPrev={prevStep}
          onNext={nextStep}
          setPlan={setPlan}
          plan={plan}
          setStep={setStep}
          step={step}
          Comunidad={Comunidad}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          resetFormContrato={resetFormContrato}
          refrescar={refrescar}
          setRefrescar={setRefrescar}
          datosCompletosComunidad={datosCompletosComunidad}
          esModificar={esModificar}
          setEsModificar={setEsModificar}
          planHistorico={planHistorico}
        />
      )}
      {step === 5 && (
        <Step5
          onPrev={prevStep}
          setPlan={setPlan}
          plan={plan}
          setStep={setStep}
          step={step}
          Comunidad={Comunidad}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          resetFormContrato={resetFormContrato}
          refrescar={refrescar}
          setRefrescar={setRefrescar}
          datosCompletosComunidad={datosCompletosComunidad}
        />
      )}
      {/*

      {step === 5 && (
        <Step5
          onPrev={prevStep}
          setPlan={setPlan}
          plan={plan}
          setStep={setStep}
          step={step}
          Comunidad={Comunidad}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          resetFormContrato={resetFormContrato}
          refrescar={refrescar}
          setRefrescar={setRefrescar}
          datosCompletosComunidad={datosCompletosComunidad}
        />
      )}
      */}
    </div>
  );
};

export default Wizard;
